<template>
  <form class="coupon-form">
    <div class="d-flex align-items-end">
      <FormInput
        name="couponCode"
        v-model="couponFields.couponCode"
        class="col-md-6"
        tes-iId="coupon-code"
        :label="$t('global.coupon-code')"
        :errors="validation.fields.couponCode.errors"
        :dirty="validation.fields.couponCode.dirty"
      />
      <Btn
        class="col-md-2 mb-2 form-control-sm"
        variant="primary"
        :loading="loading"
        @click="applyCoupon"
      >
        {{ $t("global.apply") }}
      </Btn>
      <div v-if="approved" class="coupon-approved d-flex align-items-center mb-2">
        <icon class="ml-2 mr-1" icon="success" color="sigma" />
        <div>{{ $t("global.approved") }}!</div>
      </div>
      <div v-if="error" class="coupon-error d-flex d-flex align-items-center mb-2">
        <icon class="ml-2 mr-1" icon="error" color="tau" />
        <div>{{ $t("global.invalid") }}</div>
      </div>
    </div>
  </form>
</template>

<script>
import { reactive, ref } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import { coupon as couponValidationRules } from "leatherman-js/utils/validations/forms";
import FormInput from "@/components/display/form/FormInput";
import Icon from "@/components/display/icon/Icon";
import store from "@/store";
import useValidator from "@/utils/useValidator";

export default {
  name: "CouponForm",
  components: {
    FormInput,
    Btn,
    Icon,
  },
  props: {
    amount: Number,
    couponCode: String,
    packageId: Number,
    term: {
      type: String,
      default: "monthly",
      validator: (val) => {
        return ["monthly", "annually"].includes(val);
      },
    },
  },
  setup(props, { emit, root }) {
    const loading = ref(false);
    const error = ref(false);
    const approved = ref(false);
    const couponFields = reactive({
      couponCode: null,
    });
    const { validator } = useValidator();
    const validation = validator(
      couponFields,
      couponValidationRules,
      {},
      {
        couponCode: {
          required: root.$t("validation.coupon-code-required"),
        },
      }
    );

    const applyCoupon = () => {
      error.value = false;
      approved.value = false;
      loading.value = true;
      validation.reset();
      validation
        .validate()
        .then(() => {
          return store
            .dispatch("discounts/validateCoupon", {
              amount: props.amount,
              couponCode: couponFields.couponCode,
              term: props.term,
              packageId: props.packageId,
            })
            .then((discountAmount) => {
              approved.value = true;
              emit("verify", couponFields.couponCode, discountAmount);
            })
            .catch(() => (error.value = true));
        })
        .finally(() => (loading.value = false));
    };

    return { couponFields, validation, applyCoupon, error, approved, loading };
  },
};
</script>

<style lang="scss" scoped>
.coupon-form {
  padding: 25px;
}
</style>
